import React from 'react';
import Form, { Actions, EmailAddressValidator, Password, RequiredValidator, TextField } from '../../Components/Form';
import Card from '../../Components/Containers/Card';
import { Link } from 'react-router-dom';
import { useSession } from '../../Components/Session';

const Login = () => {
    const {login} = useSession();

    return <>
        <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        />

        <Card>
            <Form onSubmit={login}>
                <TextField type="email" name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
                <Password label="Password" name="password" validators={[RequiredValidator]} />
                <Actions submit={{label: 'Login'}}
                    left={<Link to="/forgotten-password" className="inline-block mt-4 text-muted">Forgot password?</Link>}
                />
            </Form>
        </Card>

        <p className="text-center mt-4 text-muted text-sm">
            Don't have an account yet? <Link to="/register" className="link">Register for free!</Link>
        </p>
    </>;
}

export default Login;
